import Sidebar from "../components/Sidebar";
import SettingsLayout from "../components/settings/SettingsLayout";
import SettingsSections from "../components/settings/SettingsSections";

export default function Settings() {
  const role = (() => {
    try {
      return JSON.parse(localStorage.getItem("user"))?.role;
    } catch {
      return undefined;
    }
  })();

  return (
    <SettingsLayout Sidebar={Sidebar}>
      <SettingsSections role={role} />
    </SettingsLayout>
  );
}
